const SENTINEL = {};

/**
 * Decorator for memoized getter
 * @param {Object} target
 * @param {string} name
 * @param {PropertyDescriptor} descriptor
 *
 * @example
 *
 * class MyClass {
 *    @memoizeGetter get myGetter() {
 *      ...
 *    }
 * }
 */
export default function memoizeGetter(target, name, descriptor) {
  let memoizedName = `CACHED_${name}`;
  let { get } = descriptor;
  target[memoizedName] = SENTINEL;
  return {
    ...descriptor,
    get() {
      if (this[memoizedName] === SENTINEL) {
        this[memoizedName] = get.call(this);
      }
      return this[memoizedName];
    },
  };
}
